import type { ComponentProps } from "react";

export function ChevronDownOutlineIcon(props: ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M11.6402 7.34988L9.07809 10.5525C9.03805 10.6025 8.96195 10.6025 8.92191 10.5525L6.35982 7.34988"
        stroke="currentColor"
      />
    </svg>
  );
}
